import { ReactElement, useMemo, memo } from 'react';
import { ColumnDescription } from 'react-bootstrap-table-next';

import { ApiTransactionVehicle } from '~services/apiTransaction/types';
import {
  VehicleInfo,
  SkillsListInfo,
  CapabilitiesInfo,
  DataTable,
} from '~components/index';

import { TABLE_KEY_FIELDS } from '../../../../../../utils/constants';

import { useAssistantGenerateRoutesDialogByTemplateContext } from '../../../../../Context';
import { getVehicleBySelectedTemplate } from '../../../../../utils';

import { AssistantGenerateRoutesDialogByTemplateContentFormTableContainer } from '../../styles';

const AssistantGenerateRoutesDialogByTemplateContentFormTemplateSelectedDataVehicleTable =
  (): ReactElement => {
    const {
      data: {
        selectedTemplate: { value: selectedTemplate },
      },
    } = useAssistantGenerateRoutesDialogByTemplateContext();

    const data = useMemo(() => {
      const currentVehicle = getVehicleBySelectedTemplate(selectedTemplate);

      if (!currentVehicle) return [];

      return [currentVehicle];
    }, [selectedTemplate]);

    const columns = useMemo<ColumnDescription<ApiTransactionVehicle>[]>(
      () => [
        {
          dataField: 'name',
          text: 'Vehículo',
          formatter: (cell, row) => (
            <VehicleInfo
              vehicle={cell}
              vehicleCode={row.referenceCode ?? ''}
              color={row.color}
              fontWeight="bold"
              useCaption
            />
          ),
        },
        {
          dataField: 'skillsList',
          text: 'Cargas especiales',
          formatter: (cell) => <SkillsListInfo skills={cell} />,
          headerStyle: { width: 250 },
          align: 'center',
        },
        {
          dataField: 'capacity1',
          text: 'Capacidades',
          formatter: (_cell, row) => (
            <CapabilitiesInfo
              capacity1={row.capacity1}
              capacity2={row.capacity2}
              maximumVisits={row.maximumVisits}
              timeWindow={{ timeFrom: row.timeFrom, timeTo: row.timeTo }}
              fontSize={12}
              fontWeight="bold"
            />
          ),
          headerStyle: { width: 250 },
        },
      ],
      [],
    );

    return (
      <AssistantGenerateRoutesDialogByTemplateContentFormTableContainer
        sx={{ minHeight: 100 }}
      >
        <DataTable
          loading={false}
          data={data}
          columns={columns}
          keyField={TABLE_KEY_FIELDS.VEHICLE}
          condensed
        />
      </AssistantGenerateRoutesDialogByTemplateContentFormTableContainer>
    );
  };

export default memo(
  AssistantGenerateRoutesDialogByTemplateContentFormTemplateSelectedDataVehicleTable,
);
